module.exports = __webpack_public_path__ + "media/img/frontend_application/vnfc-bank-logo-dfd78ac1d8adb961f4cb13d1b4307e43.svg";